/* ============================================================
   Aline — storefront behaviours (loaded with `defer`)
   reveal · mobile menu · cart drawer (AJAX) · accordions · qty
   Progressive enhancement: every interaction has a no-JS fallback.
   ============================================================ */
(function () {
  'use strict';

  var routes = window.alineRoutes || { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' };
  var CART_SECTION = 'cart-drawer';

  /* ---------- helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function lockScroll(on) { document.documentElement.classList.toggle('aline-no-scroll', !!on); }

  /* ---------- scroll reveal ---------- */
  function initReveal() {
    var els = $all('[data-reveal]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- generic drawer open/close ---------- */
  function openDrawer(el) { if (!el) return; el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); lockScroll(true); }
  function closeDrawer(el) { if (!el) return; el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); lockScroll(false); }

  /* ---------- mobile menu ---------- */
  function initMenu() {
    var menu = $('[data-mobile-menu]');
    if (!menu) return;
    $all('[data-menu-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); openDrawer(menu); }); });
    $all('[data-menu-close]', menu).forEach(function (b) { b.addEventListener('click', function () { closeDrawer(menu); }); });
  }

  /* ---------- cart drawer ---------- */
  function setCartCount(n) {
    $all('[data-cart-count]').forEach(function (el) {
      el.textContent = el.hasAttribute('data-cart-count-bare') ? String(n) : '(' + n + ')';
    });
  }

  function refreshCart() {
    var url = (routes.root || '/') + '?sections=' + CART_SECTION;
    return fetch(url, { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[CART_SECTION];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        // Rebuild the ENTIRE drawer body (overlay + panel), not just the panel's
        // innerHTML. Shopify's cart-sync scripts can remove the [data-cart-panel]
        // element between an add and this refresh, which used to leave the drawer
        // blank; rebuilding the whole drawer is immune to that.
        var freshDrawer = doc.querySelector('[data-cart-drawer]');
        var liveDrawer = $('[data-cart-drawer]');
        if (freshDrawer && liveDrawer) {
          var wasOpen = liveDrawer.classList.contains('is-open');
          liveDrawer.innerHTML = freshDrawer.innerHTML;
          if (wasOpen) { liveDrawer.classList.add('is-open'); liveDrawer.setAttribute('aria-hidden', 'false'); }
          $all('[data-cart-close]', liveDrawer).forEach(function (b) {
            b.addEventListener('click', function () { closeDrawer(liveDrawer); });
          });
        }
        var root = $('[data-cart-root]');
        if (root) setCartCount(parseInt(root.getAttribute('data-cart-count'), 10) || 0);
        bindCartItemControls();
      });
  }

  function openCart() {
    var d = $('[data-cart-drawer]');
    if (!d) { window.location.href = routes.cart; return; }
    openDrawer(d);
  }
  // Minimal public API so other sections (e.g. the product page bundle add-to-cart)
  // can refresh + open the drawer instead of redirecting to /cart.
  window.alineCart = { refresh: refreshCart, open: openCart };

  function changeLine(key, qty) {
    return fetch(routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function () { return refreshCart(); });
  }

  function bindCartItemControls() {
    var panel = $('[data-cart-panel]');
    if (!panel) return;
    $all('[data-line-change]', panel).forEach(function (b) {
      b.addEventListener('click', function () {
        changeLine(b.getAttribute('data-key'), parseInt(b.getAttribute('data-qty'), 10));
      });
    });
  }

  function initCart() {
    var drawer = $('[data-cart-drawer]');
    $all('[data-cart-open]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
    });
    if (!drawer) return;
    $all('[data-cart-close]', drawer).forEach(function (b) { b.addEventListener('click', function () { closeDrawer(drawer); }); });
    bindCartItemControls();

    /* AJAX add-to-cart */
    $all('form.product-form, [data-product-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        if (btn) btn.setAttribute('disabled', 'disabled');
        fetch(routes.cartAdd + '.js', {
          method: 'POST',
          headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form)
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            if (!res.ok) throw res.j;
            return refreshCart().then(openCart);
          })
          .catch(function () { window.location.href = routes.cart; })
          .then(function () { if (btn) btn.removeAttribute('disabled'); });
      });
    });
  }

  /* ---------- accordions ---------- */
  function initAccordions() {
    $all('[data-accordion-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = trigger.closest('[data-accordion]');
        if (!item) return;
        var open = item.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---------- quantity steppers ---------- */
  function initQty() {
    $all('[data-qty]').forEach(function (wrap) {
      var input = $('[data-qty-input]', wrap);
      if (!input) return;
      $all('[data-qty-step]', wrap).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.getAttribute('data-qty-step'), 10) || 1;
          var min = parseInt(input.getAttribute('min'), 10) || 1;
          var val = (parseInt(input.value, 10) || min) + step;
          input.value = Math.max(min, val);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------- global key + boot ---------- */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeDrawer($('[data-cart-drawer].is-open'));
      closeDrawer($('[data-mobile-menu].is-open'));
    }
  });

  /* ---------- product gallery ---------- */
  function initGallery() {
    $all('[data-gallery]').forEach(function (g) {
      var main = $('[data-gallery-main]', g);
      if (!main) return;
      var thumbs = $all('[data-gallery-thumb]', g);

      /* Show image at idx, wrapping infinitely (last -> first, first -> last). */
      function show(idx) {
        if (!thumbs.length) return;
        idx = ((idx % thumbs.length) + thumbs.length) % thumbs.length;
        var thumb = thumbs[idx];
        var full = thumb.getAttribute('data-full');
        if (full) { main.removeAttribute('srcset'); main.src = full; }
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      }
      function currentIndex() {
        for (var i = 0; i < thumbs.length; i++) { if (thumbs[i].classList.contains('is-active')) return i; }
        return 0;
      }

      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () { show(i); });
      });

      /* Mobile: swipe the main image to move through photos, looping endlessly. */
      var stage = main.parentNode;
      var sx = 0, sy = 0, tracking = false;
      stage.addEventListener('touchstart', function (e) {
        var t = e.changedTouches[0]; sx = t.clientX; sy = t.clientY; tracking = true;
      }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (!tracking) return; tracking = false;
        var t = e.changedTouches[0];
        var dx = t.clientX - sx, dy = t.clientY - sy;
        if (Math.abs(dx) < 40 || Math.abs(dx) <= Math.abs(dy)) return; /* ignore taps + vertical scrolls */
        show(currentIndex() + (dx < 0 ? 1 : -1)); /* swipe left -> next; swipe right -> previous (conventional) */
      }, { passive: true });
    });
  }

  /* ---------- carousels (seamless infinite loop; optional autoplay) ---------- */
  function initCarousels() {
    $all('[data-carousel]').forEach(function (track) {
      var reals = Array.prototype.slice.call(track.children);
      var n = reals.length;
      if (n < 2) return;

      /* Clone last->front and first->back so scrolling past either end wraps seamlessly. */
      var head = reals[n - 1].cloneNode(true);
      var tail = reals[0].cloneNode(true);
      head.setAttribute('data-clone', ''); head.setAttribute('aria-hidden', 'true');
      tail.setAttribute('data-clone', ''); tail.setAttribute('aria-hidden', 'true');
      track.insertBefore(head, reals[0]);
      track.appendChild(tail);

      function items() { return Array.prototype.slice.call(track.children); }
      function centerOf(el) { return el.offsetLeft + el.offsetWidth / 2 - track.clientWidth / 2; }
      function goTo(i, smooth) {
        var el = items()[i];
        if (el) track.scrollTo({ left: centerOf(el), behavior: smooth ? 'smooth' : 'auto' });
      }
      function nearest() {
        var all = items(), c = track.scrollLeft + track.clientWidth / 2, best = 1, bd = Infinity;
        for (var i = 0; i < all.length; i++) {
          var d = Math.abs((all[i].offsetLeft + all[i].offsetWidth / 2) - c);
          if (d < bd) { bd = d; best = i; }
        }
        return best;
      }

      /* Real slide k (1-based) sits at child index k (the head clone shifts everything by 1). */
      var start = parseInt(track.getAttribute('data-carousel-start'), 10);
      if (!(start >= 1 && start <= n)) start = 1;
      requestAnimationFrame(function () { goTo(start, false); });

      var settle;
      track.addEventListener('scroll', function () {
        clearTimeout(settle);
        settle = setTimeout(function () {
          var i = nearest(), last = items().length - 1;
          if (i === 0) goTo(n, false);          /* head clone -> real last  */
          else if (i === last) goTo(1, false);  /* tail clone -> real first */
        }, 80);
      }, { passive: true });

      var ms = parseInt(track.getAttribute('data-carousel-autoplay'), 10);
      if (ms > 0) {
        var timer = null, paused = false;
        function step() { if (!paused) goTo(nearest() + 1, true); }
        function play() { if (!timer) timer = setInterval(step, ms); }
        function halt() { if (timer) { clearInterval(timer); timer = null; } }
        ['touchstart', 'mouseenter'].forEach(function (ev) { track.addEventListener(ev, function () { paused = true; }, { passive: true }); });
        ['touchend', 'mouseleave'].forEach(function (ev) { track.addEventListener(ev, function () { paused = false; }, { passive: true }); });
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (es) { es.forEach(function (e) { e.isIntersecting ? play() : halt(); }); }, { threshold: 0.25 }).observe(track);
        } else { play(); }
      }
    });
  }

  /* ---------- variant price / availability ---------- */
  function initVariant() {
    $all('[data-variant-select]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var opt = sel.options[sel.selectedIndex];
        var form = sel.closest('form');
        if (!form) return;
        var btn = form.querySelector('[data-add-to-cart]');
        var priceEl = form.querySelector('[data-add-price]');
        var labelEl = form.querySelector('[data-add-label]');
        var display = (form.parentNode || document).querySelector('[data-price-display]');
        var price = opt.getAttribute('data-price');
        var sold = opt.disabled;
        if (btn) { if (sold) { btn.setAttribute('disabled', 'disabled'); } else { btn.removeAttribute('disabled'); } }
        if (labelEl) labelEl.textContent = sold ? 'Sold out' : 'Add to bag';
        if (priceEl && price) priceEl.textContent = sold ? '' : price;
        if (display && price && !sold) display.textContent = price;
      });
    });
  }

  function boot() { initReveal(); initMenu(); initCart(); initAccordions(); initQty(); initGallery(); initCarousels(); initVariant(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
